const MIN_DISCOUNTED_AMOUNT = 0.01;

export const normalizeDiscountedAmount = (amount: number) => {
  const normalizedAmount = Number(amount || 0);

  if (normalizedAmount < 0) {
    return MIN_DISCOUNTED_AMOUNT;
  }

  return Number(normalizedAmount.toFixed(2));
};

export const calcOrderPayableAmount = (
  amount: number,
  discountAmount: number,
  shipping = 0
) => {
  return normalizeDiscountedAmount(
    Number(amount || 0) +
      Number(shipping || 0) -
      Number(discountAmount || 0)
  );
};
